import { render, staticRenderFns } from "./AdminPopupList.vue?vue&type=template&id=1f15920b&scoped=true&"
import script from "./AdminPopupList.vue?vue&type=script&lang=js&"
export * from "./AdminPopupList.vue?vue&type=script&lang=js&"
import style0 from "./AdminPopupList.vue?vue&type=style&index=0&id=1f15920b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15920b",
  null
  
)

export default component.exports